import { render, staticRenderFns } from "./MoveInAttachmentSelection.vue?vue&type=template&id=85a980e6"
import script from "./MoveInAttachmentSelection.vue?vue&type=script&lang=js"
export * from "./MoveInAttachmentSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports